import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Input,
  Typography,
} from "@mui/material";
import { DialogHeader } from "../../../../auth/components/DialogHeader";
import { useContext, useEffect, useState } from "react";
import { DashboardContext } from "../../context/DashboardContexProvider";
export type EditColorItemType = {
  title: string;
  value: string;
  setValue: React.Dispatch<React.SetStateAction<string>>;
};
export default function EditColorModal(props: {
  open: boolean;
  setOpen: (open: boolean) => void;
  title: string;
  onConfirm?: () => void;
  options: EditColorItemType[];
}) {
  const { open, title, setOpen, onConfirm, options } = props;
  const [defaultOptions, setDefaultoptions] = useState<EditColorItemType[]>();
  const { cardsDisplayableColorProps } = useContext(DashboardContext);
  const onClose = () => {
    options.map((option) => {
      const defaultOption = defaultOptions?.find(
        (item) => item.title === option.title
      );
      defaultOption && option.setValue(defaultOption.value);
    });
    setOpen(false);
  };

  useEffect(() => {
    setDefaultoptions(options);
  }, [cardsDisplayableColorProps]);

  return (
    <Dialog
      onClose={onClose}
      aria-labelledby="customized-dialog-title"
      open={open}
    >
      <DialogHeader id="customized-dialog-title" onClose={onClose}>
        <Typography sx={{ marginRight: "40px", fontSize: "20px" }}>
          {title}
        </Typography>
      </DialogHeader>
      <DialogContent>
        {options.map((item, i) => {
          return (
            <Box
              key={i}
              sx={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "space-between",
                width: "100%",
              }}
            >
              <Typography sx={{ marginRight: "20px" }}>{item.title}</Typography>
              <Input
                type="color"
                value={item.value}
                onChange={(e) => item.setValue(e.target.value)}
                sx={{ width: "30px", height: "50px" }}
              />
            </Box>
          );
        })}
      </DialogContent>
      <DialogActions>
        <Button color="secondary" onClick={onClose}>
          {"Cancelar"}
        </Button>
        <Button variant="contained" color={"primary"} onClick={onConfirm}>
          {"Salvar"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
